import {
  GET_RECENT_REPORTS_SUCCESS,
  SET_RECENT_REPORTS_LOADING,
  RecentReportsTypes,
  RecentReportsState,
} from './RecentReports.types';

const defaultState = {
  loading: false,
  recentReports: null,
};

export const recentReportsReducer = (
  state = defaultState,
  action: RecentReportsTypes,
): RecentReportsState => {
  switch (action.type) {
    case SET_RECENT_REPORTS_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    case GET_RECENT_REPORTS_SUCCESS: {
      return {
        ...state,
        recentReports: action.recentReports,
      };
    }
    default:
      return state;
  }
};
